export const MAX_QUESTIONS_PER_SEARCH = 10;
export const MAX_FILTERS_PER_SEARCH = 10;
export const talkjs_app_id = process.env.REACT_APP_TALKJS_APP_ID;
export const onesignal_app_id = process.env.REACT_APP_ONESIGNAL_APP_ID;
export const getTalkjsRole = () => 'data_market_redesign';
export const DATADOG_APPLICATION_ID =
  process.env.REACT_APP_DATADOG_APPLICATION_ID;
export const DATADOG_CLIENT_TOKEN = process.env.REACT_APP_DATADOG_CLIENT_TOKEN;
export const DATADOG_SITE = process.env.REACT_APP_DATADOG_SITE;
export const WEB_SITE = process.env.REACT_APP_LOGIN_REDIRECT?.replace(
  '/authorize',
  ''
);
